import {
  /* useMutation, */
  useQuery,
  /* , useQueryClient  */
} from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { getTodayAsEndDateFilterValue } from "utils";

import {
  /* getBusinessDetails, */
  getBusinessesStats,
} from ".";
import { BusinessUserManagementQueryKeys } from "./consts";
import {
  /* IGetBusinessDetailsPayload, */
  IGetBusinessStatsPayload,
} from "./types";

// Query hooks
export const useGetBusinessesStats = () => {
  const [searchParams] = useSearchParams();
  const dateRange = searchParams.get("dateRange");
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const payload: IGetBusinessStatsPayload = {};

  if (startDate) {
    payload["startDate"] = startDate;
    payload["dateRange"] = "custom";
  }

  if (endDate) {
    payload["endDate"] = endDate;
  }

  if (startDate && !endDate) {
    payload["endDate"] = getTodayAsEndDateFilterValue();
  }

  if (dateRange) {
    payload["dateRange"] = dateRange;
  }

  return useQuery({
    queryKey: [
      BusinessUserManagementQueryKeys.GET_BUSINESS_STATS,
      payload?.dateRange,
      payload?.startDate,
      payload?.endDate,
    ],
    queryFn: () => getBusinessesStats(payload),
  });
};

// export const useGetBusinessDetails = (payload: IGetBusinessDetailsPayload) => {
//   return useQuery({
//     queryKey: [
//       BusinessUserManagementQueryKeys.GET_BUSINESS_DETAILS,
//       payload.businessId,
//     ],
//     queryFn: () => getBusinessDetails(payload),
//   });
// };

// Mutation hooks
// export const useGetBusinessDetails = () => {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: api.updateBusiness,
//     onSuccess: (data, variables) => {
//       // Update cache to avoid refetching
//       queryClient.setQueryData(["business", variables.id], data);
//     },
//   });
// };
